/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React, { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

import packageJson from '../../package.json';

export interface IUseAppInfo {
  appInfoString: string;
}

const useAppInfo = (): IUseAppInfo => {
  const [appInfoString, setAppInfoString] = React.useState('');
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      App.getInfo().then((value) => {
        setAppInfoString(`Version: ${value.version}+${value.build}`);
      });
    } else {
      setAppInfoString(`Version: ${packageJson.version}+${packageJson.build}`);
    }
  }, []);

  return { appInfoString };
};

export default useAppInfo;
